import { render, staticRenderFns } from "./RenovationPage.vue?vue&type=template&id=7a612da6&scoped=true&"
import script from "./RenovationPage.vue?vue&type=script&lang=js&"
export * from "./RenovationPage.vue?vue&type=script&lang=js&"
import style0 from "./RenovationPage.vue?vue&type=style&index=0&id=7a612da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a612da6",
  null
  
)

export default component.exports